export default function ServeGraceWordmark() {
  return (
    <span className="flex items-baseline gap-0.5" aria-label="ServeGrace">
      <span
        style={{
          fontFamily: 'DM Sans, sans-serif',
          fontWeight: 300,
          fontSize: '1.125rem',
          color: '#e2e8f0',
        }}
      >
        Serve
      </span>
      <span
        style={{
          fontFamily: 'Playfair Display, Georgia, serif',
          fontWeight: 700,
          fontSize: '1.125rem',
          color: '#6366f1',
        }}
      >
        Grace
      </span>
    </span>
  );
}
